import { Injectable, Inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { WebStorageService, SESSION_STORAGE } from 'ngx-webstorage-service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuard  {
  constructor(private router: Router,  @Inject(SESSION_STORAGE) private storage: WebStorageService){}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const authenticateUser = this.storage.get("authenticateUser");
    if(authenticateUser != null && authenticateUser === 'true'){
      return true;
    }

    return this.router.parseUrl('/home');;      
  }
  
}
